export default "__VITE_ASSET__CZmZKWcT__"